import Tribute from 'tributejs'
import { userTaggingMarkup } from './user_tagging_utils.js'

/* stylesheet */
import 'tributejs/dist/tribute.css'
import 'stylesheets/tribute-custom.less'

const { usersTaggingSearchPath } = await fetch('/json_exports.json?path=user_tagging').then((response) => response.json());

let controller; // to abort the call (in Safari, the interface exists but currently does nothing...)

// Returns array of user data objects, an empty array or false
// Every time the user makes a new request i.e. types a character, we cancel the previous request
async function remoteFetch(text) {
  controller = new AbortController();
  let path = $.addSearchParams({ url: usersTaggingSearchPath, paramsObj: { text }})
  return await fetch(path, { signal: controller.signal })
    .then(response => response.ok ? response.json() : [])
    .catch(() => false)
}

async function getRedactorElement(container) {
  return await new Promise(function (resolve) {
    let editor;
    let interval = setInterval(() => {
      editor = container.parentNode.querySelector('[contenteditable="true"]');
      if (editor) {
        clearInterval(interval);
        resolve(editor);
      }
    })
  })
}

let suggestions_cache = {},
  options = {
    trigger: '@',
    allowSpaces: true,
    requireLeadingSpace: false,
    lookup: 'username',
    fillAttr: 'username',
    loadingItemTemplate: '<div style="padding: 16px">Loading...</div>',
    noMatchTemplate: '',
    replaceTextSuffix: '&#32;&#8203;', // default is &nbsp; but this causes overflow when several taggings follow in a row
    // menuShowMinLength: 3, // this option is inconsistent when deleting
    values: async function(text, callback) {
      controller && controller.abort(); // if controller exists (previous request) then abort
      if (text.length < 3) return callback([]);
      let suggestions = suggestions_cache[text];
      if (!suggestions) {
        suggestions = await remoteFetch(text);
        if (!suggestions) return;
        if (suggestions.length) suggestions_cache[text] = suggestions;
      }
      callback(suggestions);
    },
    selectTemplate(item) {
      return userTaggingMarkup(`/users/${item.original.slug}`, item.original.username)
    },
  },
  tribute = new Tribute(options),
  observer;

async function initializeTribute(tributeElement) {
  if (tributeElement.dataset.gitbTribute === 'redactor') {
    tributeElement = await getRedactorElement(tributeElement);
  }
  tribute.attach(tributeElement);
}

// use MutationObserver to attach Tribute to elements dynamically added to the DOM
// inside of a data-gitb-tribute-container
function observerCallback(mutationList) {
  mutationList.filter(mutation => mutation.type === 'childList' && mutation.addedNodes.length)
    // mutation.addedNodes is a NodeList object, we need it to be an array to flatten
    .flatMap(mutation => [...mutation.addedNodes])
    .filter(node => node.nodeType === Node.ELEMENT_NODE && Object.keys(node.dataset).includes('gitbTribute'))
    .forEach(initializeTribute);
}
observer = new MutationObserver(observerCallback);

document.querySelectorAll('[data-gitb-tribute]').forEach(initializeTribute);
document.querySelectorAll('[data-gitb-tribute-container]')
  .forEach(container => observer.observe(container, { childList: true, subtree: true }));